import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { CellKeyDownEvent, FullWidthCellKeyDownEvent, ColDef, RowClickedEvent } from 'ag-grid-community';
import { RelationshipRow } from './relationship.models';

@Component({
  selector: 'app-relationship-grid',
  standalone: true,
  imports: [AgGridModule],
  templateUrl: './relationship-grid.component.html',
  styleUrls: ['./relationship-grid.component.scss']
})
export class RelationshipGridComponent {
  @Input() rows: RelationshipRow[] = [];
  @Input() dark = false;
  @Input() loading = false;
  @Input() disabled = false;
  @Output() readonly open = new EventEmitter<RelationshipRow>();

  readonly defaultColumn: ColDef<RelationshipRow> = { flex: 1, minWidth: 140, sortable: true, resizable: true };
  readonly columns: ColDef<RelationshipRow>[] = [
    { field: 'source_name', headerName: 'Customer / source', valueFormatter: params => params.value || 'Domain-wide' },
    { field: 'target_name', headerName: 'Carrier / target', minWidth: 180 },
    { field: 'type_label', headerName: 'Relationship', minWidth: 150 },
    { field: 'preference_count', headerName: 'Rules', minWidth: 80, maxWidth: 90, type: 'numericColumn' }
  ];

  openRow(event: RowClickedEvent<RelationshipRow>): void {
    if (event.data && !this.disabled) this.open.emit(event.data);
  }

  openWithKeyboard(event: CellKeyDownEvent<RelationshipRow> | FullWidthCellKeyDownEvent<RelationshipRow>): void {
    if (event.event instanceof KeyboardEvent && event.event.key === 'Enter' && event.data && !this.disabled) {
      this.open.emit(event.data);
    }
  }
}
